import { ExternalCalendar } from '@griply/types';
import { sortCalendarsByName } from '@griply/utils';
import { useMemo } from 'react';

export type UseExternalConnectionCalendarsResult = {
  calendars: ExternalCalendar[];
  isLoading: boolean;
};

export const useExternalConnectionCalendars = (
  data: ExternalCalendar[] | undefined,
  isLoading: boolean,
): UseExternalConnectionCalendarsResult => {
  const calendars = useMemo(() => sortCalendarsByName(data ?? []), [data]);

  return { calendars, isLoading };
};
